import React, { useState, useEffect } from "react";
import FadeLoader from "react-spinners/FadeLoader";
import Table from "components/Table";
import Columns from "./Column";
import { get } from "helpers/api_helper";
import { getSocketEmit, getValuesSocketData } from "helpers/secretManager";
import useSocket from "hooks/useSocket";

const List = () => {
  const { socket, socketConnect } = useSocket();

  const [columns, setcolumns] = useState([{ dataField: "", text: "" }]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (socketConnect) {
      getApiData();
    }
    setcolumns(Columns({}));
  }, [socketConnect]);

  async function getApiData() {
    try {
      setLoading(true);
      const response = await getSocketEmit(socket, "getStatisticsData", {
        key: "winners",
      });
      if (response?.status && typeof response?.data !== "string") {
        setData(response?.data || []);
      }
    } catch (error) {
      setLoading(false);
      console.error(error, "ERROR");
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}

      <section className="section">
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="card-header">
                  <h2 className="section-title">Winners List</h2>
                </div>
              </div>
            </div>
          </div>
          {data?.length > 0 && (
            <Table
              data={data}
              columns={columns}
              setFilter={() => console.warn()}
              total={100}
              filter={{
                page: 1,
                limit: 100,
                order: -1,
                orderBy: "line",
              }}
            />
          )}
          {!loading && data?.length === 0 && (
            <p style={{ textAlign: "center" }}>No Record Found</p>
          )}
        </div>
      </section>
    </>
  );
};

export default List;
